<template>
    <form class="vue__filter-container" :class="{ 'vue__loading' : filters.loadingFilters }">
        <div v-if="filters.loadingFilters" class="vue__loader"></div>

        <span class="vue__mobile-filter-toggle" @click="openFilterBlock('mobile_toggle')">
            <div class="vue__filter-title-container"
                 :class="{ 'vue__filter-title-container--open' : filterVisibility['mobile_toggle'] }">
                <h5 class="vue__filter-title">{{ filtersLabel }}</h5>
            </div>
        </span>

        <div class="vue__filters" :class="{ 'vue__filters--open' : filterVisibility['mobile_toggle'] }">
            <!-- Product filters -->
            <div v-if="resetFilterState" class="vue__filter-block vue__filter-block--search-reset">
                <h5 @click="resetFilters()" class="vue__filter-title vue__filter-title--reset"><span class="vue__reset"><span
                        class="vue__cross"></span></span>{{ resetLabel }}</h5>
            </div>

            <div v-if="postType == 'catalogus'" class="vue__filter-block">
                <div class="vue__filter-title-container" @click="openFilterBlock('product_search')"
                     :class="{ 'vue__filter-title-container--open' : filterVisibility['product_search'] }">
                    <h5 class="vue__filter-title">{{ searchLabel }}</h5>
                </div>
                <div class="vue__text-container"
                     :class="{ 'vue__text-container--open' : filterVisibility['product_search'] }">
                    <form class="vue__text-inner">
                        <input type="text" v-model="settedFilters.productTextSearch" :placeholder="searchLabel"/>
                        <button type="submit" @click="generateUrlParameters($event)"
                                @blur="generateUrlParameters($event)">
                            <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg">
                                <defs>
                                    <path d="M20 18.586L18.586 20l-4.243-4.242 1.414-1.415L20 18.586zM8 14c-3.308 0-6-2.691-6-6 0-3.308 2.692-6 6-6s6 2.692 6 6c0 3.309-2.692 6-6 6zM8 0a8 8 0 100 16A8 8 0 008 0z"
                                          id="a"></path>
                                </defs>
                                <g fill="none" fill-rule="evenodd">
                                    <mask id="b" fill="#fff">
                                        <use xlink:href="#a"></use>
                                    </mask>
                                    <use fill="#000" xlink:href="#a"></use>
                                    <g mask="url(#b)" fill="#6F6F6F">
                                        <path d="M-2-2h24v24H-2z"></path>
                                    </g>
                                </g>
                            </svg>
                        </button>
                    </form>
                </div>
            </div>

            <div class="vue__filter-block" v-for="radio in filters.productRadio" :style="{ order: radio.order }">
                <div class="vue__filter-title-container" @click="openFilterBlock(radio.visibilityName)"
                     :class="{ 'vue__filter-title-container--open' : filterVisibility[radio.visibilityName] }">
                    <h5 class="vue__filter-title">{{ radio.title }}</h5>
                </div>
                <ul class="vue__filter-items"
                    :class="{ 'vue__filter-items--open' : filterVisibility[radio.visibilityName] }">
                    <li class="vue__filter-item">
                        <div class="vue__checkbox-container">
                            <label for="all" class="vue__checkbox vue__checkbox--radio">
                                <input id="all" :name="radio.name" type="radio" value="all"
                                       @change="changeCheckbox('', 'radio', radio.name)" checked>
                                <span class="vue__checker"></span>
                                <p class="vue__checkbox-label vue__checkbox-label--capitalize">{{
                                        radio.firstLabel
                                    }}</p>
                            </label>
                        </div>
                    </li>
                    <li v-for="item in radio.items" class="vue__filter-item">
                        <div class="vue__checkbox-container">
                            <label :for="item.name" class="vue__checkbox vue__checkbox--radio">
                                <input :id="item.name" :name="radio.name" type="radio" :value="item.name"
                                       @change="changeCheckbox(item.name, 'radio', radio.name)">
                                <span class="vue__checker"></span>
                                <p class="vue__checkbox-label vue__checkbox-label--capitalize">{{ item.name }}</p>
                            </label>
                        </div>
                    </li>
                </ul>
            </div>

            <div class="vue__filter-block" v-for="taxonomy in filters.productTaxonomiesCheckbox"
                 :style="{ order: taxonomy.order }">
                <div class="vue__filter-title-container" @click="openFilterBlock(taxonomy.visibilityName)"
                     :class="{ 'vue__filter-title-container--open' : filterVisibility[taxonomy.visibilityName] }">
                    <h5 class="vue__filter-title">{{ taxonomy.title }}</h5>
                </div>
                <ul class="vue__filter-items"
                    :class="{ 'vue__filter-items--open' : filterVisibility[taxonomy.visibilityName] }">
                    <li v-for="item in taxonomy.items" class="vue__filter-item">
                        <div class="vue__checkbox-container">
                            <label class="vue__checkbox">
                                <input type="checkbox" :id="item.id" :value="item.id"
                                       @change="changeCheckbox(item.id, 'taxonomy', taxonomy.name)">
                                <span class="vue__checker"></span>
                                <p class="vue__checkbox-label">{{ item.name }}</p>
                            </label>
                        </div>
                    </li>
                </ul>
            </div>

            <div class="vue__filter-block" v-for="taxonomy in filters.productTaxonomiesDropdown"
                 :style="{ order: taxonomy.order }">
                <div class="vue__filter-title-container" @click="openFilterBlock(taxonomy.visibilityName)"
                     :class="{ 'vue__filter-title-container--open' : filterVisibility[taxonomy.visibilityName] }">
                    <h5 class="vue__filter-title">{{ taxonomy.title }}</h5>
                </div>
                <div class="vue__filter-select-container"
                     :class="{ 'vue__filter-select-container--open' : filterVisibility[taxonomy.visibilityName] }">
                    <select :id="taxonomy.name" class="vue__filter-select"
                            @change="changeDropdown($event, 'taxonomy', taxonomy.name)">
                        <option selected value="0">{{ taxonomy.firstLabel }}</option>
                        <option v-for="item in taxonomy.items" :id="item.id" :value="item.id">
                            {{ item.name }}
                        </option>
                    </select>
                </div>
            </div>

            <div class="vue__filter-block" v-for="(range, index) in filters.ranges" :style="{ order: range.order }">
                <div class="vue__filter-title-container" @click="openFilterBlock(range.name)"
                     :class="{ 'vue__filter-title-container--open' : filterVisibility[range.name] }">
                    <h5 class="vue__filter-title">{{ range.title }}</h5>
                </div>
                <div class="vue__filter-range" :class="{ 'vue__filter-range--open' : filterVisibility[range.name] }">
                    <form class="vue__filter-range-inner">
                        <p class="vue__filter-prefix">{{ range.prefix }}</p>
                        <input :id="'vue__range-min-' + index" type="number" v-model="range.min_value"/>
                        <p class="vue__filter-between">Tot</p>
                        <input :id="'vue__range-max-' + index" type="number" v-model="range.max_value"/>
                        <button :data-id="index" class="vue__filter-range-submit"
                                @click="generateUrlParameters($event, index)"></button>
                    </form>
                    <div class="vue__filter-range-slider">
                        <div :id="'vue__range-slider-' + index" :data-min="range.min_value"
                             :data-max="range.max_value"></div>
                    </div>
                </div>
            </div>

            <!-- Project filters -->
            <div class="vue__filter-block" v-for="filterBlock in filters.allExternalProjectFilters">

                <div class="vue__filter-title-container" @click="openFilterBlock(filterBlock.slug)"
                     :class="{ 'vue__filter-title-container--open' : filterVisibility[filterBlock.slug] }">
                    <h5 class="vue__filter-title">{{ filterBlock.name }}</h5>
                </div>

                <!-- Projectfilter -> text -->
                <div v-if="filterBlock.type == 'text'" class="vue__text-container"
                     :class="{ 'vue__text-container--open' : filterVisibility[filterBlock.slug] }">
                    <form class="vue__text-inner">
                        <input type="text" v-model="filterBlock.value" :placeholder="filterBlock.name"/>
                        <button type="submit" @click="generateUrlParameters($event)"
                                @blur="generateUrlParameters($event)">
                            <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg"
                                 xmlns:xlink="http://www.w3.org/1999/xlink">
                                <defs>
                                    <path d="M20 18.586L18.586 20l-4.243-4.242 1.414-1.415L20 18.586zM8 14c-3.308 0-6-2.691-6-6 0-3.308 2.692-6 6-6s6 2.692 6 6c0 3.309-2.692 6-6 6zM8 0a8 8 0 100 16A8 8 0 008 0z"
                                          id="a"></path>
                                </defs>
                                <g fill="none" fill-rule="evenodd">
                                    <mask id="b" fill="#fff">
                                        <use xlink:href="#a"></use>
                                    </mask>
                                    <use fill="#000" xlink:href="#a"></use>
                                    <g mask="url(#b)" fill="#6F6F6F">
                                        <path d="M-2-2h24v24H-2z"></path>
                                    </g>
                                </g>
                            </svg>
                        </button>
                    </form>
                </div>

                <!-- Projectfilter -> radio -->
                <ul v-if="filterBlock.type == 'radio'" class="vue__filter-items"
                    :class="{ 'vue__filter-items--open' : filterVisibility[filterBlock.slug] }">
                    <li class="vue__filter-item">
                        <div class="vue__checkbox-container">
                            <label for="all" class="vue__checkbox vue__checkbox--radio">
                                <input type="radio" id="all" :name="filterBlock.slug" value="all"
                                       v-model="filterBlock.checked" @change="generateUrlParameters()" checked>
                                <span class="vue__checker"></span>
                                <p class="vue__checkbox-label vue__checkbox-label--capitalize">All</p>
                            </label>
                        </div>
                    </li>
                    <li v-for="item in filterBlock.items" class="vue__filter-item">
                        <div class="vue__checkbox-container">
                            <label :for="item.value" class="vue__checkbox vue__checkbox--radio">
                                <input type="radio" :id="item.value" :name="filterBlock.slug" :value="item.value"
                                       v-model="filterBlock.checked" @change="generateUrlParameters()">
                                <span class="vue__checker"></span>
                                <p class="vue__checkbox-label vue__checkbox-label--capitalize">{{ item.name }}</p>
                            </label>
                        </div>
                    </li>
                </ul>

                <!-- Projectfilter -> checkbox -->
                <ul v-if="filterBlock.type == 'checkbox'" class="vue__filter-items"
                    :class="{ 'vue__filter-items--open' : filterVisibility[filterBlock.slug] }">
                    <li v-for="item in filterBlock.items" class="vue__filter-item">
                        <div class="vue__checkbox-container">
                            <label class="vue__checkbox">
                                <input type="checkbox" :id="item.slug" :value="item.slug" v-model="item.checked"
                                       @change="generateUrlParameters()">
                                <span class="vue__checker"></span>
                                <p class="vue__checkbox-label">{{ item.name }}</p>
                            </label>
                        </div>
                    </li>
                </ul>

                <!-- Projectfilter -> dropdown -->
                <div v-if="filterBlock.type == 'dropdown'" class="vue__filter-select-container"
                     :class="{ 'vue__filter-select-container--open' : filterVisibility[filterBlock.slug] }">
                    <select :id="filterBlock.slug" v-model="filterBlock.selected" class="vue__filter-select"
                            @change="generateUrlParameters()">
                        <option selected value="0">{{ filterBlock.placeholder }}</option>
                        <option v-for="item in filterBlock.items" :id="item.value" :value="item.value">
                            {{ item.name }}
                        </option>
                    </select>
                </div>

            </div>

        </div>
    </form>
</template>

<script>

import Vue from 'vue'
import EventBus from '../eventBus'
import noUiSlider from 'nouislider'
import wNumb from 'wnumb'
import setPostType from '../mixins/setPostType'
import setLanguage from '../mixins/setLanguage'
import setBlogId from '../mixins/setBlogId'
import generateUrlParameters from '../mixins/buildApiUrl'
import fillByPageLoadParameters from '../mixins/fillByParameters'
import axios from "axios";

export default {
    data() {
        return {
            language: String,
            loadingFilters: true,
            settedFilters: {
                checkedTaxonomies: {
                    website_main_category: [''],
                    product_category: [],
                    thema_value: [],
                    primary_play_value_id: Number,
                    secondary_play_value_ids: [],
                    segments: [],
                    project_countries: String,
                },
                productTextSearch: "",
                ranges: []
            },
            resetFilterState: false,
            postType: String,
            filterVisibility: {},
            resetLabel: 'Filters verwijderen',
            filtersLabel: 'Filters',
            searchLabel: 'Zoeken',
            settedFiltersFromACF: []
        }
    },
    props: {
        filters: Object
    },
    mixins: [setLanguage, setPostType, setBlogId, generateUrlParameters, fillByPageLoadParameters],
    created() {
        this.postType = this.setPostType();
        this.language = this.setLanguage();
        this.blogId = this.setBlogId();
    },
    mounted() {
        this.fillFilterBlocks();
        this.prefillSettedRanges();
        this.initializeRangeSliders();
        this.setSearchLabel();
        this.setFiltersResetLabel();

        EventBus.$on('UPDATE_FILTERS_FROM_ACF_AFTER_PAGE_LOAD', acfFilters => {
            // console.log('eventBus', acfFilters);
            if (acfFilters) {
                this.settedFiltersFromACF = acfFilters;
                this.fillByPageLoadParameters(true);
            }
        });

        EventBus.$on('UPDATE_FILTERS_AFTER_PAGE_LOAD', test => {
            // console.log('filters loaded');
            this.fillByPageLoadParameters();
            this.prefillSettedExternalFilters();
            this.showResetButton();
        });

        EventBus.$on('UPDATE_CATALOG_BY_PARAM', payLoad => {
            this.generateUrlParameters(false, null, payLoad);
        });
    },
    methods: {
        showResetButton() {
            let _this = this;

            if (this.postType == 'catalogus') {
                let searchValue = (this.settedFilters.productTextSearch.length > 0) ? true : false;
                let websiteMainCategory = (this.settedFilters.checkedTaxonomies.website_main_category[0].length > 0) ? true : false;
                let productCategory = (this.settedFilters.checkedTaxonomies.product_category.length > 0) ? true : false;
                let themaValue = (this.settedFilters.checkedTaxonomies.thema_value.length > 0) ? true : false;
                let primaryPlayValueId = (this.settedFilters.checkedTaxonomies.primary_play_value_id > 0) ? true : false;
                let secondaryPlayValueIds = (this.settedFilters.checkedTaxonomies.secondary_play_value_ids.length > 0) ? true : false;
                let rangeItemsBool = false;

                let rangeItems = _this.settedFilters.ranges;
                for (var forKey = 0; forKey < rangeItems.length; forKey++) {

                    let minVal = parseInt(rangeItems[forKey].min_value);
                    let maxVal = parseInt(rangeItems[forKey].max_value);

                    let startMaxVal = rangeItems[forKey].start_max_value;

                    if (minVal > 0 || maxVal < startMaxVal) {
                        rangeItemsBool = true;
                    }
                }


                console.log('resetButton', searchValue, websiteMainCategory, productCategory, themaValue, primaryPlayValueId, secondaryPlayValueIds, rangeItemsBool);

                if (searchValue || websiteMainCategory || productCategory || themaValue || primaryPlayValueId || secondaryPlayValueIds || rangeItemsBool) {
                    this.resetFilterState = true;
                } else {
                    this.resetFilterState = false;
                }
            } else if (this.postType == 'projecten') {

                let searchValue = false;
                let anyCheckbox = false;
                let anyDropdown = false;

                if (this.filters.allExternalProjectFilters[0].value) {
                    if (this.filters.allExternalProjectFilters[0].value.length > 0) {
                        searchValue = true;
                    }
                }

                let externalFilters = this.filters.allExternalProjectFilters;
                // Loop through all externalFilters
                for (var key in externalFilters) {
                    // Check for filter type
                    if (this.filters.allExternalProjectFilters[key].type == 'checkbox') {
                        // Check if at least 1 item is checked, if true then set filter state to true
                        let externalFilterTypeItems = this.filters.allExternalProjectFilters[key].items;
                        for (var ekey in externalFilterTypeItems) {
                            if (externalFilterTypeItems[ekey].checked) {
                                anyCheckbox = true;
                                break;
                            }
                        }
                    } else if (this.filters.allExternalProjectFilters[key].type == 'dropdown') {
                        if (this.filters.allExternalProjectFilters[key].selected != "0") {
                            anyDropdown = true;
                        }
                    }
                }

                console.log('resetButton', searchValue, anyCheckbox, anyDropdown);

                if (searchValue || anyCheckbox || anyDropdown) {
                    this.resetFilterState = true;
                } else {
                    this.resetFilterState = false;
                }
            }
        },
        resetFilters() {
            let _this = this;
            this.resetFilterState = false;

            if (this.postType == 'catalogus') {
                this.settedFilters.productTextSearch = '';
                this.settedFilters.checkedTaxonomies.website_main_category[0] = '';
                this.settedFilters.checkedTaxonomies.product_category = [];
                this.settedFilters.checkedTaxonomies.thema_value = [];
                this.settedFilters.checkedTaxonomies.primary_play_value_id = [];
                this.settedFilters.checkedTaxonomies.secondary_play_value_ids = [];

                let rangeItems = _this.settedFilters.ranges;
                for (var forKey = 0; forKey < rangeItems.length; forKey++) {

                    let startMinVal = rangeItems[forKey].start_min_value;
                    let startMaxVal = rangeItems[forKey].start_max_value;

                    rangeItems[forKey].min_value = startMinVal;
                    rangeItems[forKey].max_value = startMaxVal;

                    let sliderInstance = document.getElementById('vue__range-slider-' + forKey);
                    sliderInstance.noUiSlider.updateOptions({
                        start: [startMinVal, startMaxVal]
                    });

                }
            } else if (this.postType == 'projecten') {
                // Empty search text field
                if (this.filters.allExternalProjectFilters[0].value) {
                    this.filters.allExternalProjectFilters[0].value = '';
                }

                let externalFilters = this.filters.allExternalProjectFilters;
                // Loop through all externalFilters
                for (var key in externalFilters) {
                    // Check for filter type
                    if (this.filters.allExternalProjectFilters[key].type == 'checkbox') {
                        // Set all checked to false
                        let externalFilterTypeItems = this.filters.allExternalProjectFilters[key].items;
                        for (var ekey in externalFilterTypeItems) {
                            if (externalFilterTypeItems[ekey].checked) {
                                externalFilterTypeItems[ekey].checked = false;
                            }
                        }
                    } else if (this.filters.allExternalProjectFilters[key].type == 'dropdown') {
                        this.filters.allExternalProjectFilters[key].selected = "0";
                    }
                }
            }

            this.generateUrlParameters();

            // Reset checkboxes and radio buttons
            let checkBoxes = document.querySelectorAll('[type=checkbox], [type=radio]');
            for (var key = 0; key < checkBoxes.length; key++) {
                if (checkBoxes[key].checked == true) {
                    checkBoxes[key].checked = false;
                }
                if (checkBoxes[key].getAttribute('name') == 'website_main_category' && checkBoxes[key].getAttribute('value') == 'all') {
                    checkBoxes[key].checked = true;
                }
            }

            // Reset select
            if (this.postType == 'catalog') {
                document.getElementById('primary_play_value_id').getElementsByTagName('option')[0].selected = 'selected'
            }

        },
        determineLanguage(values = Object) {
            if (typeof values == 'object') {
                let lang = this.language;
                return values[lang];
            } else {
                console.error('Input is not an object, some translations wont show');
            }
        },
        setSearchLabel() {
            this.searchLabel = this.determineLanguage({nl: 'Zoeken', en: 'Search', de: 'Suche'});
        },
        setFiltersResetLabel() {
            this.resetLabel = this.determineLanguage({
                nl: 'Filters verwijderen',
                en: 'Reset filters',
                de: 'Alle Filter löschen'
            })
        },
        fillFilterBlocks() {
            let filterBlocks = {};

            let checkedTaxonomiesObject = this.settedFilters.checkedTaxonomies;
            for (var key in checkedTaxonomiesObject) {
                filterBlocks[key] = false;

                if (key == 'primary_play_value_id') {
                    filterBlocks[key] = true;
                }
            }

            // Add mobile filter toggle
            filterBlocks['mobile_toggle'] = false;

            // Separate for product search
            filterBlocks['product_search'] = true;

            // Separate for secondary play values
            filterBlocks['secondary_play_value_ids'] = false;

            // Add ranges
            filterBlocks['falling_height'] = true;
            filterBlocks['list_price'] = true;

            // console.log(filterBlocks);
            this.filterVisibility = filterBlocks;
        },
        openFilterBlock(name) {
            if (this.filterVisibility[name] == false) {
                this.filterVisibility[name] = true;
            } else {
                this.filterVisibility[name] = false;
            }
            this.$forceUpdate();
        },
        prefillSettedRanges() {
            let _this = this;
            // this.filters.ranges.forEach(function (rangeItem) {
            //     _this.settedFilters.ranges.push(rangeItem);
            // });

            let filtersRanges = this.filters.ranges;
            for (var key in filtersRanges) {
                _this.settedFilters.ranges.push(filtersRanges[key]);
            }
        },
        initializeRangeSliders() {
            // Loop throug sliders and create noUiSlider instances

            let _this = this;
            let rangeSliders = document.querySelectorAll('[id^=vue__range-slider]');

            for (var key = 0; key < rangeSliders.length; key++) {

                // rangeSliders.forEach(function (rangeSlider, index) {

                let rangeMin = parseInt(rangeSliders[key].dataset.min);
                let rangeMax = parseInt(rangeSliders[key].dataset.max);
                noUiSlider.create(rangeSliders[key], {
                    start: [rangeMin, rangeMax],
                    connect: true,
                    range: {
                        'min': rangeMin,
                        'max': rangeMax
                    },
                    format: wNumb({
                        decimals: 0
                    })
                });

                let minId = 'vue__range-min-' + key;
                let maxId = 'vue__range-max-' + key;

                let minMaxInputs = [
                    document.getElementById(minId),
                    document.getElementById(maxId)
                ];

                // Connect slider handles to input values
                const newKey = key
                rangeSliders[newKey].noUiSlider.on('update', function (values, handle) {
                    // minMaxInputs[handle].value = values[handle]

                    _this.settedFilters.ranges[newKey]['min_value'] = values[0]
                    _this.settedFilters.ranges[newKey]['max_value'] = values[1]
                });

                // When releasing handle update catalog
                rangeSliders[key].noUiSlider.on('change', function (values, handle) {
                    _this.generateUrlParameters();
                });
            }
        },
        changeCheckbox(value, type, tax) {
            // console.log(value);
            // console.log(type);
            // console.log(tax);

            if (type == 'taxonomy' || type == 'project_checkbox') {

                // Fill the correct array in 'settedFilters.checkedTaxonomies' with the ID of the checked term
                let relatedArray = this.settedFilters.checkedTaxonomies[tax];

                // Remove ID if already exists, add if not
                const index = relatedArray.indexOf(value);
                if (index > -1) {
                    relatedArray.splice(index, 1);
                } else {
                    relatedArray.push(value);
                }

                this.generateUrlParameters();
            } else if (type == 'radio') {

                // Empty array before adding value because it's a radio button (only 1 value allowed)
                this.settedFilters.checkedTaxonomies[tax] = [];

                // Add value
                this.settedFilters.checkedTaxonomies[tax].push(value);

                this.generateUrlParameters();
            } else if (type == 'string') {
                let relatedArray = this.settedFilters.checkedTaxonomies[tax];

                let index = relatedArray.indexOf(value)

                if (index > -1) {
                    relatedArray.splice(index, 1);
                } else {
                    relatedArray.push(value);
                }

                this.generateUrlParameters();
            }
        },
        changeDropdown(event, type, tax) {
            if (type == 'taxonomy') {
                let id = event.target.value;
                if (id && id !== 0 && id !== '0') {
                    id = parseInt(id);
                    // console.log(id);

                    this.settedFilters.checkedTaxonomies[tax] = id;

                    this.generateUrlParameters();
                } else if (id == 0) {
                    // console.log(id);

                    this.settedFilters.checkedTaxonomies[tax] = [];
                    this.generateUrlParameters();
                } else {
                    console.warn('Value not set in <select>')
                }
            } else if (type == 'string') {
                let string = event.target.value;
                if (string) {
                    // console.log(string);

                    this.settedFilters.checkedTaxonomies[tax] = string;

                    this.generateUrlParameters();
                } else {
                    console.warn('Value not set in <select>')
                }
            }
        },

        // Projects related functions (MyYalp api)
        prefillSettedExternalFilters() {
            // Visibility status only
            let _this = this

            // Filters from loadfilters component
            let loadedFilters = this.filters.allExternalProjectFilters;

            for (var key in loadedFilters) {

                // Set visibility status
                _this.filterVisibility[loadedFilters[key]['slug']] = loadedFilters[key]['open'];

                // Set default for dropdowns
                if (loadedFilters[key]['type'] == 'dropdown') {
                    if (window.location.href.indexOf("country") == -1) {
                        loadedFilters[key]['selected'] = '0';

                    }
                }
            }
        },
        isElement(obj) {
            try {
                //Using W3 DOM2 (works for FF, Opera and Chrome)
                return obj instanceof HTMLElement;
            } catch (e) {
                //Browsers not supporting W3 DOM2 don't have HTMLElement and
                //an exception is thrown and we end up here. Testing some
                //properties that all elements have (works on IE7)
                return (typeof obj === "object") &&
                        (obj.nodeType === 1) && (typeof obj.style === "object") &&
                        (typeof obj.ownerDocument === "object");
            }
        }
    }
}
</script>
